<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        <p class="card-header-title">Setup Account</p>
                        <div class="header-buttons">
                            <a class="button is-danger" v-on:click="resetAwardedPoints()">Reset Awarded Points</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading"
                            :can-cancel="false"
                            :is-full-page="true">
                        </loading>
                        <div class="columns">
                            <div class="column is-6">
                                <input class="input is-success" type="text" placeholder="Institution/School/Company Name" v-model="name">
                            </div>
                            <div class="column is-6">
                                <input class="input" type="text" placeholder="Address" v-model="address">
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-3">
                                <b-select id="organization" name="organization" v-model="organization">
                                    <option value="1">School</option>
                                    <option value="2">Institution/Company</option>
                                </b-select>
                            </div>
                            <div class="column is-6">
                                <b-select id="selectSchoolType" name="selectSchoolType" v-model="schoolType">
                                    <option value="-1">Please Select Your School/Organization Type</option>
                                    <option v-for="template in templateList" :key="template._id" :value="template._id">{{ template.name }}</option>
                                </b-select>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-2">
                                <b-checkbox v-model="isNewLogo" v-on:change="isEnableNewLogo()">
                                    Upload new logo
                                </b-checkbox>
                            </div>
                            <div class="column is-10">
                                <b-notification type="is-warning" :closable="false" style="padding: 10px; font-size: 12px;">
                                    Only JPEG and non-interlaced PNG image is supported. If you have problem generating QR tags, try resaving the logo file and reupload it here.
                                </b-notification>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <div class="label">Logo</div>
                                <div class="control">
                                    <input type="file" id="file" ref="file" accept="image/*" v-on:change="handleFileUpload()" :disabled="!isNewLogo" />
                                    <img v-bind:src="imagePreview" v-show="showPreview"/>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-4" style="margin-top: 10px;">
                                <b-checkbox v-model="isNewPassword" v-on:change="isEnableNewPassword()">
                                    Change Password for <b>{{ adminEmail }}</b>
                                </b-checkbox>
                            </div>
                            <div class="column is-4">
                                <input class="input" type="password" placeholder="Password (enter new password to change)" v-model="password1" :disabled="!isNewPassword">
                            </div>
                            <div class="column is-4">
                                <input class="input" type="password" placeholder="New password, again" v-model="password2" :disabled="!isNewPassword">
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full"><button class='button is-primary  is-fullwidth' v-on:click="update()" >Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "Setup",
    components: {
        NewTopMenu,
        Loading,
    },
    data() {
        return {
            schoolID: "",
            schoolInfo: "",
            adminEmail: "",
            name: "",
            address: "",
            organization: 1,
            schoolType: -1,
            isNewLogo: false,
            isNewPassword: false,
            password1: "",
            password2: "",
            file: '',
            showPreview: false,
            imagePreview: '',
            templateList: []
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.adminEmail = localStorage.getItem('email')
        this.schoolID = localStorage.getItem('schoolID');
        this.getSchoolInfo()
        this.getTemplates()
    },
    mounted(){
    },
    methods: {
        getSchoolInfo(){
            let self = this
            self.isLoading = true
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/schoolV2/info', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.schoolInfo = response.data
                self.isLoading = false
                self.name = self.schoolInfo.name
                self.address = self.schoolInfo.address
                self.organization = self.schoolInfo.organization
                self.schoolType = self.schoolInfo.schoolType
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },        
        getTemplates(){
            let self = this;
            self.isLoading = true;
            self.templateList = []

            console.log("axios ke: " + process.env.NEW_ENDPOINT + '/behaviors/template/list')
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/template/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                withItems: false,
            }).then(response => {
                self.templateList = response.data
                self.isLoading = false
            })
            .catch(e => {
                self.isLoading = false
                console.log(e)
            })
        },
        update() {
            console.log("imini 140")
            let self = this

            if (this.schoolType == "-1"){
                Toast.open({
                    message: "Please select your school type.",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
                return false;
            }
            if (this.name.length > 0) {

                let formData = new FormData();

                if (self.isNewLogo){

                    console.log(self.file)

                    var fileExtension = helper.getExtension(self.file.name)
                    console.log("fileExtension: " + fileExtension)

                    if ((fileExtension == "jpg") || (fileExtension == "png")){
                        console.log("file extension ok")
                    }else{
                        Toast.open({
                            message: "Sorry, you can only upload jpg or png file.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        return false;
                    }

                    var fileSize = self.file.size
                    console.log("fileSize: " + fileSize)

                    if (fileSize > 500000){
                        this.$swal({
                            title: "Error",
                            text: "Sorry, you can only upload file not more than 500KB. Please compress the image at tinypng.com first.",
                            icon: "error",
                            html:
                                "Sorry, you can only upload file not more than 500KB. " +
                                "Please compress the image at <u><a href='//tinypng.com' target='_blank'>tinypng.com</a></u> first",
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            showCloseButton: false,
                            confirmButtonColor: '#41b882'
                        })
                        return false;                       
                        // Toast.open({
                        //     message: "Sorry, you can only upload file not more than 500KB.",
                        //     type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        //     duration: 5000
                        // })
                        // return false;
                    }


                    if (self.file.name == null){
                        Toast.open({
                            message: "You chose to upload a new logo. Please select the image you want to upload.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        return false;
                    }
                }

                var isNewLogo = 0;
                if (this.isNewLogo){
                    isNewLogo = 1;
                }
                var isNewPassword = 0;
                var newPassword = "";
                if (this.isNewPassword){
                    if (this.password1.length >= 8){
                        if (this.password1 == this.password2){
                            isNewPassword = 1;
                            newPassword = this.password1
                        }else{
                            Toast.open({
                                message: "Please make sure you typed in the correct new password in both fields.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                            return false;
                        }
                    }else{
                        Toast.open({
                            message: "Password must be at least 8 characters.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        return false;
                    }
                }

                self.isLoading = true;

                formData.append('token', localStorage.getItem('jwtTokenV2'));
                formData.append('email', localStorage.getItem('email'));
                formData.append('file', this.file);
                formData.append('name', this.name);
                formData.append('address', this.address);
                formData.append('organization', this.organization);
                formData.append('isNewLogo', isNewLogo);
                formData.append('isNewPassword', isNewPassword);
                formData.append('newPassword', newPassword);
                formData.append('schoolType', this.schoolType);

                this.email = localStorage.getItem('email')

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'

                /*
                    Make the request to the POST /single-file URL
                */
                axios.post(process.env.MY_URL + '/schoolV2/update',
                        formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        console.log('SUCCESS!!');
                        console.log(response)
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                            this.file = ""
                            this.imagePreview = ""

                            if (this.isNewPassword){
                                alert("Profile updated. Since you've changed your password, you will be logged out. Please login again using your new password.")
                                this.logout()
                            }
                        }
                        self.isLoading = false
                    })
                    .catch(e => {
                        console.log(e.response)
                        self.isLoading = false
                        Toast.open({
                            message: "Error! " + e.response,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    });
            } else {
                Toast.open({
                    message: "Please enter the school's name!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
            }
        },
        logout(){
            localStorage.removeItem('user')
            localStorage.removeItem('jwtToken')
            localStorage.removeItem('email')
            localStorage.removeItem('sessionID')
            localStorage.removeItem('schoolID')
            localStorage.removeItem('schoolName')
            localStorage.removeItem('schoolLogo')
            this.$emit("authenticated", false)

            this.$router.push({
                name: "Login"
            });
        },
        isEnableNewLogo(){
            if (isNewLogo){
                this.isNewLogo = true;
            }else{
                this.isNewLogo = false;
            }
        },
        handleFileUpload() {
            /*
            Set the local file variable to what the user has selected.
            */
            this.file = this.$refs.file.files[0];

            /*
            Initialize a File Reader object
            */
            let reader = new FileReader();

            /*
            Add an event listener to the reader that when the file
            has been loaded, we flag the show preview as true and set the
            image to be what was read from the reader.
            */
            reader.addEventListener("load", function () {
                this.showPreview = true;
                this.imagePreview = reader.result;
            }.bind(this), false);

            /*
            Check to see if the file is not empty.
            */
            if (this.file) {
                /*
                    Ensure the file is an image file.
                */
                if (/\.(jpe?g|png)$/i.test(this.file.name)) {
                    /*
                    Fire the readAsDataURL method which will read the file in and
                    upon completion fire a 'load' event which we will listen to and
                    display the image in the preview.
                    */
                    reader.readAsDataURL(this.file);
                    console.log("fileName: " + this.file.name)
                }else{
                    Toast.open({
                        message: "Sorry, you can only upload jpg or png files.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }
            }
        },
        resetAwardedPoints(){
            this.$swal({
                title: "Are you sure?",
                text: "ALL POINTS and SUBMISSIONS awarded to EVERYONE for ALL BEHAVIORS will be REMOVED PERMANENTLY. This should only be used if you want to START OVER using this system from ZERO. This action CANNOT BE UNDONE! To continue, enter your password in the text field below and press OK",
                type: 'warning',
                input: 'password',
                confirmButtonColor: '#CCCCCC',
                cancelButtonColor: '#d33',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (value.length > 1){

                        axios.post(process.env.NEW_ENDPOINT + '/submissions/reset', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            password: value
                        }).then(response => {
                                if (response.data.success == false) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    })
                                } else {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-success',
                                        duration: 3000
                                    })
                                }
                            })
                            .catch(e => {
                                console.log(e.response)
                                if (e.response.status === 401) {
                                    Toast.open({
                                        message: "Unauthorized access. Please re-login.",
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                } else {
                                    this.errors.push(e)
                                    Toast.open({
                                        message: e,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                }
                            })

                    }else{
                        alert("You need to enter your password to reset the awarded points.")
                    }
                }
            });
        },
        goOverallAnalysis() {
            this.$router.push({
                name: "OverallAnalysis"
            });
        },
    },
};
</script>

<style scoped>
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Setup.vue